import en_US from '../locales/en-US'
import ja_JP from '../locales/ja-JP'
import zh_CN from '../locales/zh-CN'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  'en-US': en_US,
  'zh-CN': zh_CN,
  'ja-JP': ja_JP,
} as const
